<template>
    <div class="invoice-main-data-view detail-card">
        <el-form ref="form" :rules="rules" :model="simpleInfo">
            <div class="title-block">
                <invoice-status-label :status-num="form.status" />
                <div class="title">
                    <div class="edit-form" v-if="isEditMode">
                        <el-form-item prop="description" style="margin-bottom: 0">
                            <el-input v-model="simpleInfo.description" size="small" />
                        </el-form-item>
                        <div v-if="isEditMode">
                            <el-button size="mini" :loading="isLoading" @click="onInit">
                                <i class="el-icon-close"></i>
                            </el-button>
                            <el-button size="mini" :loading="isLoading" type="primary" @click="onSubmit">
                                <i class="el-icon-check"></i>
                            </el-button>
                        </div>
                    </div>
                    <div v-else class="edit-form">
                        <div>{{ form.description }}</div>
                        <div>
                            <el-button v-if="isEditable" size="mini" type="primary" plain class="el-icon-edit" @click="onEdit"> </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 收支項目 -->
            <StateItemInlineEditor
                v-if="isStateItemInlineEditorShow"
                style="margin-bottom: 15px"
                type="invoice"
                size="small"
                :sno="form.sno"
                :receipt-accno="form.accno"
                :itemSno="form.incomeItemNo"
                :enable="isAuthOne(['B02', 'B03']) && form.status !== 5"
                @changed="$emit('stateItemChange')"
            />
            <el-row :gutter="40" style="margin-bottom: 15px">
                <el-col :sm="14">
                    <spec-view>
                        <spec-item label="發票類型">
                            {{ getInvoiceType(form.typ) }}
                            <el-button v-if="form.typ == 1" size="small" :loading="isLoading" @click="downloadPdf">
                                下載 PDF
                            </el-button>
                        </spec-item>
                        <spec-item label="買受人(客戶)">
                            <div>{{ form.vdR_NAM }}</div>
                            <div v-if="form.bsn">統編：{{ form.bsn }}</div>
                        </spec-item>
                        <spec-item v-if="form.typ != 4" label="預計發票日期">
                            {{ form.foO_PDAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="預計收款日">
                            <div v-if="!editPdatEnable" style="display: inline-flex; align-items: center;">
                                <span>{{ form.pdat | dateFormater("YYYY-MM-dd") }}</span>
                                <el-button
                                    v-if="isPdatEditable"
                                    size="mini"
                                    plain
                                    @click="handleEditPdatBtnClick"
                                    icon="el-icon-edit"
                                    style="padding: 3px 7px; margin-left: 10px"
                                    type="text"
                                ></el-button>
                            </div>
                            <div v-else class="edit-dat-set">
                                <el-date-picker
                                    ref="editPdatDatePicker"
                                    v-model="editPdatDate"
                                    type="date"
                                    value-format="timestamp"
                                    placeholder="選擇新日期"
                                    size="small"
                                    :clearable="false"
                                ></el-date-picker>
                                <span class="actions">
                                    <el-button size="mini" type="danger" icon="el-icon-close" @click="handleEditPdatCancelBtnClick"></el-button>
                                    <el-button size="mini" type="success" icon="el-icon-check" :loading="isPdatLoading" @click="handleEditPdatSubmitBtnClick"></el-button>
                                </span>
                            </div>
                        </spec-item>
                        <spec-item label="申請備註" v-if="form.mem || isEditMode">
                            <el-input v-if="isEditMode" v-model="simpleInfo.mem" size="small" :loading="isLoading" />
                            <span v-else>{{ form.mem }}</span>
                        </spec-item>
                    </spec-view>
                </el-col>
                <el-col :sm="10">
                    <spec-view>
                        <spec-item label="申請人">
                            {{ form.stF_NAM }}
                        </spec-item>
                        <spec-item label="申請時間">
                            {{ form.crT_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                    </spec-view>
                </el-col>
            </el-row>
        </el-form>
        <!-- 專案 -->
        <InvoiceProjectView ref="InvoiceProjectView" :projects="form.projects" @show="$event => $emit('show', $event)" />
        <!-- 發票項目 -->
        <InvoiceItemView ref="InvoiceItemView" style="margin-top: 30px" :invoiceItems="form.invoiceItems" />
        <div class="amt-summary">
            <spec-view style="">
                <spec-item label="銷售額(未稅)">
                    <Money :v="netAmount" :precision="form.cny === 'TWD' ? null : 4" />
                    <span style="margin-left: 10px; font-weight: bold;">{{ form.cny }}</span>
                </spec-item>
                <spec-item label="稅額">
                    <Money :v="form.amT_TAX" :precision="form.cny === 'TWD' ? null : 4" :round="form.cny === 'TWD'" />
                    <span style="margin-left: 10px; font-weight: bold;">{{ form.cny }}</span>
                </spec-item>
                <spec-item v-if="!form.foO_DIS_CNL && form.foO_DIS_AMT" label="折讓退回">
                    <Money :v="form.foO_DIS_AMT" />
                    <span style="margin-left: 10px; font-weight: bold;">{{ form.cny }}</span>
                </spec-item>
                <spec-item label="含稅總計">
                    <Money :v="form.amt" style="font-size: 20pt" :precision="form.cny === 'TWD' ? null : 4" />
                    <span style="margin-left: 10px; font-weight: bold;">{{ form.cny }}</span>
                </spec-item>
                <template v-if="form.cny !== 'TWD'">
                    <spec-item label="申請時匯率">
                        <Money :v="form.appliedRat" :precision="form.cny === 'TWD' ? null : 4" />
                        <span style="margin-left: 41px;"></span>
                    </spec-item>
                    <spec-item label="約當台幣">
                        <Money :v="form.amt * form.appliedRat" round />
                        <span style="margin-left: 10px; font-weight: bold;">TWD</span>
                    </spec-item>
                </template>
            </spec-view>
        </div>
    </div>
</template>

<script>
import { invoiceType } from '@/assets/commonData/options';
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';
import StateItemInlineEditor from '@/components/ui/StateItemInlineEditor_New.vue';
import InvoiceStatusLabel from '../InvoiceStatusLabel.vue';
import InvoiceItemView from './InvoiceItemView.vue';
import InvoiceProjectView from './InvoiceProjectView.vue';

export default {
    props: {
        invoiceItems: {
            type: Array,
            default: () => [],
        },
        form: {
            type: Object,
            default: () => {},
        },
        isAuditFlowSettingEnable: Boolean,
        isCreator: Boolean,
    },
    components: {
        InvoiceStatusLabel,
        InvoiceItemView,
        InvoiceProjectView,
        StateItemInlineEditor,
        SpecView,
        SpecItem,
    },
    computed: {
        netAmount() {
            return this.form.amt - Math.round(this.form.amT_TAX);
        },
        isEditable() {
            if (this.form.status === 0) return this.isCreator;
            if (this.form.status === 1) return this.isAuth('B02');
            if (this.form.status === 2 || this.form.status === 3) return this.isAuth('B03');

            return false;
        },
        isStateItemInlineEditorShow() {
            return this.form.incomeItemNo && this.form.status !== 0 && this.form.status !== 1 && this.form.status !== 4;
        },
        isPdatEditable() {
            if ([3, 4, 5].includes(this.form.status)) return false;
            return this.isAuthOne(['B02', 'B03']);
        },
    },
    data() {
        return {
            isEditMode: false,
            isLoading: false,

            editPdatEnable: false,
            editPdatDate: null,
            isPdatLoading: false,

            simpleInfo: {
                description: null,
                mem: null,
            },
            rules: {
                description: [{ required: true, message: '請輸入摘要', trigger: 'blur' }],
            },
        };
    },
    watch: {
        form() {
            this.onInit();
        },
    },
    methods: {
        downloadPdf() {
            this.$router.push({
                name: 'invoice-pdf',
                params: { sno: this.form.sno },
            });
        },
        getInvoiceType(type) {
            if (type) {
                const typeObj = invoiceType.find((x) => x.key === type);
                if (typeObj) {
                    return typeObj.value;
                }
            }

            return type;
        },

        onInit() {
            this.isEditMode = false;
            this.editPdatEnable = false;
            this.simpleInfo = {
                description: this.form.description,
                mem: this.form.mem,
            };
        },
        onEdit() {
            this.isEditMode = true;
        },
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;
                        await this.$api({
                            url: '/InvoiceManagemnetPage/UpdateEInvoiceSimpleInfo',
                            method: 'POST',
                            data: {
                                sno: this.form.sno,
                                description: this.simpleInfo.description,
                                pdat: this.form.pdat,
                                mem: this.simpleInfo.mem,
                            },
                        });
                        this.$emit('reload');
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        handleEditPdatBtnClick() {
            this.editPdatEnable = true;
            this.editPdatDate = this.form.pdat;
            this.$nextTick(() => {
                if (this.$refs.editPdatDatePicker) {
                    this.$refs.editPdatDatePicker.focus();
                }
            });
        },
        handleEditPdatCancelBtnClick() {
            this.editPdatEnable = false;
        },
        handleEditPdatSubmitBtnClick() {
            if (this.editPdatDate === this.form.pdat) {
                this.editPdatEnable = false;
                return;
            }

            this.isPdatLoading = true;
            this.$api({
                url: '/InvoiceManagemnetPage/UpsertInvoicePdat',
                method: 'POST',
                data: {
                    sno: this.form.sno,
                    pdat: this.editPdatDate,
                },
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '預計收款日已修改。',
                        type: 'success',
                    });
                    this.$emit('reload');
                })
                .finally(() => {
                    this.isPdatLoading = false;
                    this.editPdatEnable = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-main-data-view {
    .title-block {
        margin: 15px 0 20px 0;
        display: flex;
        align-items: center;
        .title {
            font-size: 15pt;
            font-weight: bold;
            margin: 3px 0 0 15px;
            flex: 1;
        }
    }
    .edit-form {
        flex: 1;
        display: flex;
        align-items: center;
        > *:nth-child(1) {
            flex: 1;
            margin-right: 10px;
        }
        > *:nth-child(2) {
            width: 100px;
            display: flex;
            justify-content: flex-end;
        }
    }
    .edit-dat-set {
        display: flex;
        align-items: center;
        gap: 10px;

        .actions {
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }
}
</style>

<style lang="scss">
.invoice-main-data-view .spec-view .spec-item .value {
    vertical-align: top;
}
</style>
